import { ArrowLeftIcon } from 'lucide-react'

type Props = {
  onClick: () => void
  disabled?: boolean
}
export default function BackButton(props: Props) {
  return (
    <button
      disabled={props.disabled}
      onClick={props.onClick}
      className="p-2 border-none disabled:opacity-80 hover:bg-themed-grey-400 active:scale-95 hover:cursor-pointer bg-themed-grey-200 flex items-center justify-center rounded-full"
    >
      <ArrowLeftIcon className="flex-none" />
    </button>
  )
}
